import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import adminReducer from './slices/admin.slice';
import billsReducer from './slices/bills.slice';
import counterReducer from './slices/counter.slice';
import sessionReducer from './slices/session.slice';
import userReducer from './slices/user.slice';
import venueReducer from './slices/venue.slice';
import venueSearchReducer from './slices/venueSearch.slice';

const persistConfig = {
  key: 'pagcomanda:store',
  storage,
  blacklist: ['admin', 'session', 'venueSearch'],
};

const rootReducer = combineReducers({
  admin: adminReducer,
  counter: counterReducer,
  bills: billsReducer,
  session: sessionReducer,
  user: userReducer,
  venue: venueReducer,
  venueSearch: venueSearchReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store);
